<template>
  <div>
    <!-- <CookiesBanner :class="[themeClass]"/> -->
    <!-- <AddToHomeScreenModal></AddToHomeScreenModal> -->
    <base-dialog v-model="sharedDialogVisible" :content="$store.state.sharedDialog.content" :okFn="$store.state.sharedDialog.okFn" :okBtnText="$store.state.sharedDialog.okBtnText" :size="$store.state.sharedDialog.size"></base-dialog>
    <component :is="layoutType" :class="[ themeClass, { 'forum-class': $route.meta.forumClass } ]"></component>
    <Footer/>
  </div>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue'
import Footer from '@/components/public/footers/Footer.vue'
import { getThemeName } from '@/constants/themes'
/* import AddToHomeScreenModal from '@/components/utils/AddToHomeScreenModal.vue' */

export default {
  components: {
    BaseDialog,
    Footer
    /* AddToHomeScreenModal */
  },
  data () {
    return {
    }
  },
  computed: {
		sharedDialogVisible: {
			get () {
				return this.$store.state.sharedDialog.visible
			},
			set (value) {
				this.$store.commit('setSharedDialogVisible', value)
			}
		},
    layoutType () {
      return this.$route.meta.layout || 'p'
    },
    themeName () {
      return this.$route.meta.theme || (typeof (THEME_NAMES) !== 'undefined' ? getThemeName() : 'opensalud')
    },
    themeClass () {
      return `${this.themeName}-theme`
    }
  }
}
</script>

<style lang="scss">

html {
  font-size: 14px !important;
}

/* .opensalud-theme {
  @import '../../../static-appopensalud/css/bootstrap-custom-theme-morillas.scss';
}

.openlegal-theme {
  @import '../../../static-appopensalud/css/openlegal/bootstrap-custom-theme-morillas-openlegal.scss';
}

.unipromel-theme {
  @import '../../../static-appopensalud/css/unipromel/bootstrap-custom-theme-morillas-unipromel.scss';
} */

$inhealth-color: #6F7880 !default;

.inhealth-theme {
	.btn-primary {
		background-color: $inhealth-color !important;
		border-color: $inhealth-color !important;
	}

	a {
		color: $inhealth-color !important;
	}
}

</style>


// WEBPACK FOOTER //
// src/components/layouts/BaseLayout.vue